export default "__VITE_ASSET__DzsjZRVn__"